import { Box } from "@mui/material";
import ExtraInput from "components/common/ExtraInput";
import { useDispatch, useSelector } from "react-redux";
import * as programPricingStore from "store/programPricing";

// Wide, self-sizing inputs get a row to themselves; everything else packs
// into the grid columns.
const spansFullRow = (definition) =>
  definition.type === "table" ||
  definition.textFieldProps?.multiline === true ||
  definition.textFieldProps?.fullWidth === true;

const CoverageExtraInputsPanel = ({ peril, definitions }) => {
  const dispatch = useDispatch();
  // Subscribe to just this peril's values so keystrokes in one panel don't
  // re-render every other open panel.
  const perilInputs = useSelector(
    (state) => programPricingStore.selectInput(state)?.extraInputs?.[peril]
  );

  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
        gap: 2,
        py: 1,
      }}
      onKeyDown={(event) => event.stopPropagation()}
    >
      {(definitions ?? []).map((definition) => (
        <Box
          key={definition.key}
          sx={spansFullRow(definition) ? { gridColumn: "1 / -1" } : undefined}
        >
          <ExtraInput
            definition={definition}
            value={perilInputs?.[definition.key] ?? null}
            setValue={(value) =>
              dispatch(
                programPricingStore.updatePathValue({
                  path: ["extraInputs", peril, definition.key],
                  value,
                })
              )
            }
          />
        </Box>
      ))}
    </Box>
  );
};

export default CoverageExtraInputsPanel;
